<div class="overflow-container">
    <div class="label" [ngClass]="{ ellipsis: ellipsis }">
        {{ name }}
    </div>
</div>
